import { render, staticRenderFns } from "./DashboardHeader.vue?vue&type=template&id=7d1c74dc&scoped=true"
import script from "./DashboardHeader.vue?vue&type=script&lang=js"
export * from "./DashboardHeader.vue?vue&type=script&lang=js"
import style0 from "./DashboardHeader.vue?vue&type=style&index=0&id=7d1c74dc&prod&lang=scss&scoped=true"
import style1 from "./DashboardHeader.vue?vue&type=style&index=1&id=7d1c74dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1c74dc",
  null
  
)

export default component.exports